(() => {
  if (window.akumaSizeGuideLoaded) return;
  window.akumaSizeGuideLoaded = true;
  const mobile = matchMedia('(max-width:989px)');
  let active = null;
  function initDesktopGuides() {
    document.querySelectorAll('dialog.akuma-size-guide').forEach(dialog => {
      if (document.getElementById(dialog.id + '-desktop')) return;
      const panel = document.createElement('section');
      panel.className = 'akuma-size-guide akuma-guide-desktop';
      panel.id = dialog.id + '-desktop';
      panel.dataset.section = dialog.dataset.section;
      panel.dataset.profile = dialog.dataset.profile;
      const intro = document.createElement('div'); intro.className = 'akuma-guide-intro';
      const copy = JSON.parse(dialog.querySelector('[data-guide-strings]').textContent);
      const eyebrow = document.createElement('p'); eyebrow.className = 'akuma-guide-eyebrow'; eyebrow.textContent = copy.desktop_eyebrow; intro.append(eyebrow);
      const heading = dialog.querySelector('h3').cloneNode(true); intro.append(heading);
      for (const key of ['desktop_intro', 'desktop_help']) {
        const paragraph = document.createElement('p'); paragraph.textContent = copy[key]; intro.append(paragraph);
      }
      const link = document.createElement('button'); link.type = 'button'; link.className = 'akuma-size-guide-link';
      link.textContent = dialog.querySelector('h2').textContent;
      link.dataset.akumaSizeGuideOpen = dialog.id; link.dataset.guideTable = 'true'; link.setAttribute('aria-haspopup','dialog'); intro.append(link);
      panel.setAttribute('aria-label', heading.textContent);
      const controls = document.createElement('div'); controls.className = 'akuma-guide-controls';
      controls.append(dialog.querySelector('.akuma-guide-tabs').cloneNode(true), dialog.querySelector('form').cloneNode(true));
      panel.append(intro, controls);
      const data = document.createElement('div'); data.hidden = true;
      data.append(dialog.querySelector('[data-guide-table]').cloneNode(true));
      panel.append(data, dialog.querySelector('[data-guide-strings]').cloneNode(true), dialog.querySelector('[data-guide-options]').cloneNode(true));
      panel.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      dialog.after(panel);
      const product = document.getElementById('MainProduct-' + dialog.dataset.section);
      const purchase = product?.querySelector('.product__info-container');
      if (purchase) {
        const align = () => {
          if (!panel.isConnected) { observer.disconnect(); return; }
          if (!matchMedia('(min-width:990px)').matches) return;
          const box = purchase.getBoundingClientRect(), outer = panel.getBoundingClientRect();
          panel.style.setProperty('--akuma-fit-width', box.width + 'px');
          panel.style.setProperty('--akuma-fit-right', Math.max(0, outer.right - box.right) + 'px');
        };
        const observer = new ResizeObserver(align);
        observer.observe(purchase); observer.observe(product); observer.observe(panel);
        align();
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(panel)) observer.disconnect();
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDesktopGuides);
  else initDesktopGuides();
  document.addEventListener('shopify:section:load', initDesktopGuides);
  const normalSize = value => String(value).toUpperCase().replace(/\s/g, '').replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL');
  const clearResult = dialog => { dialog.querySelector('[data-guide-result]').hidden = true; };
  document.addEventListener('input', event => {
    const dialog = event.target.closest('.akuma-size-guide');
    if (dialog) clearResult(dialog);
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-guide-form]')) return;
    event.preventDefault();
    const form = event.target, dialog = form.closest('.akuma-size-guide');
    if (!form.reportValidity()) return;
    const strings = JSON.parse(dialog.querySelector('[data-guide-strings]').textContent);
    const options = JSON.parse(dialog.querySelector('[data-guide-options]').textContent).map(normalSize);
    const rows = [...dialog.querySelectorAll('[data-guide-size]')].map(row => ({
      size: row.dataset.guideSize,
      chest: Number(row.querySelectorAll('[data-measure-cm]')[0].dataset.measureCm),
      length: Number(row.querySelectorAll('[data-measure-cm]')[1].dataset.measureCm)
    })).filter(row => options.includes(row.size));
    const imperial = dialog.dataset.unit === 'in';
    const read = name => Number(form.elements.namedItem(name).value);
    let match, estimatedChest, lengthUpgrade = false;
    const garment = dialog.dataset.method === 'garment';
    if (garment && rows.length) {
      const chest = read('chest') * (imperial ? 2.54 : 1);
      const length = read('length') * (imperial ? 2.54 : 1);
      // Only match within the measured range (2 cm edge tolerance); never invent extra sizes.
      const inRange = (value, key) => value >= Math.min(...rows.map(r => r[key])) - 2 && value <= Math.max(...rows.map(r => r[key])) + 2;
      if (inRange(chest, 'chest') && inRange(length, 'length')) {
        match = [...rows].sort((a,b) => ((a.chest-chest)**2 + (a.length-length)**2) - ((b.chest-chest)**2 + (b.length-length)**2))[0];
      }
    } else if (!garment) {
      const height = Math.round(read('height') * (imperial ? 2.54 : 1) * 100) / 100;
      const weight = read('weight') * (imperial ? 0.45359237 : 1);
      const sizes = ['S','M','L','XL','2XL'];
      // Merchant calibration, not validated anthropometry. The chest approximation fits
      // six supplied competitor examples; grading and 12 cm ease are our explicit assumptions.
      // Height determines a starting grade; width can increase it, never reduce it.
      if (height > 0 && height < 160 && weight > 0) {
        // Explicit merchant rule: below 160 cm always start with S.
        match = rows.find(row => row.size === 'S');
      } else if (height >= 160 && height <= 200 && weight >= 40 && weight <= 160) {
        const baseIndex = [170,180,185,190,200].findIndex(n => height <= n);
        estimatedChest = Math.round(0.18 * height + 0.6 * weight + 23);
        match = rows.find(row => sizes.indexOf(row.size) >= baseIndex && row.chest * 2 >= estimatedChest + 12);
        lengthUpgrade = match && sizes.indexOf(match.size) > baseIndex;
      }
    }

    const result = dialog.querySelector('[data-guide-result]');
    result.replaceChildren();
    const heading = document.createElement('strong');
    heading.textContent = match ? `${garment ? strings.closest : strings.rough} ${match.size}` : strings.none;
    result.append(heading);
    if (match) {
      const unit = imperial ? 'in' : 'cm';
      const format = n => new Intl.NumberFormat(document.documentElement.lang || 'en', {maximumFractionDigits:1}).format(imperial ? n / 2.54 : n);
      const values = {chest:format(match.chest), length:format(match.length), estimate:format(estimatedChest), unit, size:match.size};
      const fill = text => text.replace(/\{(\w+)\}/g, (_,key) => values[key]);
      const details = document.createElement('p');
      details.textContent = (garment || estimatedChest === undefined ? '' : fill(strings.estimate) + ' ') + fill(strings.details);
      result.append(details);
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'akuma-guide-calculate';
      button.dataset.guideApply = match.size; button.textContent = fill(strings.continue);
      result.append(button);
    }
    if (match) { const note = document.createElement('p'); note.textContent = (lengthUpgrade ? strings.longer + ' ' : '') + strings.check; result.append(note); }
    result.hidden = false;
  });
  function closeGuide() {
    if (!active) return;
    const { dialog, trigger, style, y } = active;
    active = null;
    dialog.close();
    document.body.style.cssText = style;
    window.scrollTo({ top:y, behavior:'instant' });
    if (trigger.isConnected) trigger.focus({ preventScroll:true });
  }
  document.addEventListener('click', (event) => {
    const apply = event.target.closest('[data-guide-apply]');
    if (apply) {
      const dialog = apply.closest('.akuma-size-guide');
      const product = document.getElementById('MainProduct-' + dialog.dataset.section);
      const radio = [...(product?.querySelectorAll('.akuma-size-picker input[type=radio]') || [])].find(input => normalSize(input.value) === apply.dataset.guideApply);
      if (!radio || radio.disabled || radio.classList.contains('disabled') || radio.classList.contains('visually-disabled')) {
        const strings = JSON.parse(dialog.querySelector('[data-guide-strings]').textContent);
        apply.textContent = strings.unavailable; apply.disabled = true;
        return;
      }
      closeGuide();
      radio.checked = true;
      radio.dispatchEvent(new Event('change', {bubbles:true}));
      radio.focus({preventScroll:true});
      return;
    }
    const trigger = event.target.closest('[data-akuma-size-guide-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.akumaSizeGuideOpen);
      if (!dialog) return;
      event.preventDefault();
      closeGuide();
      const y = window.scrollY;
      active = { dialog, trigger, y, style:document.body.style.cssText };
      document.body.style.position = 'fixed';
      document.body.style.top = `${-y}px`;
      document.body.style.width = '100%';
      dialog.showModal();
      const body = dialog.querySelector('.akuma-size-guide-body');
      body.scrollTop = trigger.dataset.guideTable === 'true'
        ? dialog.querySelector('[data-guide-table-start]').offsetTop - body.offsetTop : 0;
      dialog.querySelector('[data-guide-close]').focus({ preventScroll:true });
    }
    if (event.target.closest('[data-guide-close]')) closeGuide();
    const methodButton = event.target.closest('[data-guide-method]');
    if (methodButton) {
      const dialog = methodButton.closest('.akuma-size-guide'), method = methodButton.dataset.guideMethod;
      dialog.dataset.method = method;
      dialog.querySelectorAll('[data-guide-method]').forEach(button => button.setAttribute('aria-pressed', String(button === methodButton)));
      dialog.querySelectorAll('[data-guide-fields]').forEach(group => {
        group.hidden = group.dataset.guideFields !== method;
        group.querySelectorAll('input').forEach(input => { input.disabled = group.hidden; });
      });
      dialog.querySelectorAll('[data-method-note]').forEach(note => { note.hidden = note.dataset.methodNote !== method; });
      dialog.querySelectorAll('[data-body-unit-label]').forEach((label,index) => { label.textContent = method === 'garment' ? ['CM','IN'][index] : ['cm / kg','in / lb'][index]; });
      clearResult(dialog);
    }
    const unitButton = event.target.closest('[data-guide-unit]');
    if (unitButton) {
      const dialog = unitButton.closest('.akuma-size-guide');
      const unit = unitButton.dataset.guideUnit;
      const previous = dialog.dataset.unit || 'cm';
      if (previous !== unit) {
        dialog.querySelectorAll('input[type=number]').forEach(input => {
          if (!input.value) return;
          const factor = input.name === 'weight' ? 1 / 0.45359237 : 1 / 2.54;
          input.value = (Number(input.value) * (unit === 'in' ? factor : 1 / factor)).toFixed(4);
        });
        dialog.dataset.unit = unit;
        clearResult(dialog);
      }
      dialog.querySelectorAll('[data-length-unit]').forEach(span => { span.textContent = unit; });
      dialog.querySelectorAll('[data-weight-unit]').forEach(span => { span.textContent = unit === 'in' ? 'lb' : 'kg'; });
      dialog.querySelectorAll('[data-guide-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideUnit === unit)));
      dialog.querySelectorAll('[data-measure-cm]').forEach(cell => {
        const cm = Number(cell.dataset.measureCm);
        cell.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits:unit === 'in' ? 2 : 1 }).format(unit === 'in' ? cm / 2.54 : cm);
      });
      dialog.querySelector('[data-guide-current-unit]').textContent = unit;
    }
  });
  document.addEventListener('cancel', event => {
    if (event.target === active?.dialog) { event.preventDefault(); closeGuide(); }
  }, true);
  document.addEventListener('click', event => {
    if (event.target === active?.dialog) {
      const rect = active.dialog.getBoundingClientRect();
      if (event.clientY < rect.top || event.clientY > rect.bottom || event.clientX < rect.left || event.clientX > rect.right) closeGuide();
    }
  });

  document.addEventListener('shopify:section:unload', closeGuide);
})();

